import Vue from 'vue';
import { HTTP } from '../../../../utils/httpCommonUtil';
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner';
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import flatPickr from 'vue-flatpickr-component';
import format from 'date-fns/format';
import { UserRoleEnum } from '@/enums/userRolesEnum';
import GenericModal from '@/componentsReusable/genericModal.vue';

export default Vue.component('shift-notes-card', {
  name: 'ShiftNotesCard',
  data () {
    let emptyArray: Array<any> = [];
    return {
      cardExpanded: false,
      loadingInitialData: false,
      savingNewShiftNote: false,
      shiftNotes: emptyArray,
      isAuthorizedToDelete: false,
      showConfirmationModal: false,
      pendingDeleteId: null,
      numShiftNotes: 0,
      noteErrorMessage: ''
    }
  },
  components: {
    flatPickr,
    BallPulseLoader,
    VueSimpleSpinner,
    GenericModal
  },
  beforeMount: function () {
    this.isAuthorizedToDelete = this.$store.getters['user/hasRole']([UserRoleEnum.MANAGER]);
    this.getNumShiftNotes();
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'M.D.YY - HH:mm');
      return tempString;
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getShiftNotes()
      }
    },
    getNumShiftNotes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/shifts/' + this.$route.params.shiftId + '/num-shift-notes')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Number of Shift Notes.");
        }
        self.numShiftNotes = response.data.data[0].numShiftNotes;
      })
      .catch(function () {
        console.log('response Error!');
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Number of Shift Notes.'
        });
      })
    },
    getShiftNotes () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingInitialData = true;
      }, 0);
      HTTP.get('/api/shifts/' + this.$route.params.shiftId + '/shift-notes')
      .then(function (response) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        if (!response.data || !response.data.data) { 
          throw new Error("Error retrieving Shift Notes.");
        }
        let freshShiftNotes = response.data.data;
        freshShiftNotes.forEach( function (shiftNote: any) {
          shiftNote.isEditing = false;
          shiftNote.isViewing = true;
          shiftNote.isNew = false;
          shiftNote.updatingData = false;
          shiftNote.note = shiftNote.note.trim();
          shiftNote.taid = "taShiftNote" + shiftNote.noteId;
        });

        self.shiftNotes = freshShiftNotes;
      })
      .catch(function (err) {
        console.log('response Error! ' + err);
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingInitialData = false;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred retrieving Shift Notes.'
        });
      })
    },
    saveShiftNote (newShiftNote: any) {
      let self = this
      const entityType = 14; // This is found in the DB. In this case this type means "SHIFT_NOTE"
      self.savingNewShiftNote = true;

      HTTP.post('/api/shift-note/', {
        "entityId": this.$route.params.shiftId,
        "entityType": entityType,
        "note": newShiftNote.note
      })
      .then(function (response) {
        self.savingNewShiftNote = false;
        newShiftNote.isEditing = false;
        self.getNumShiftNotes();
        self.getShiftNotes();
      })
      .catch(function (err) {
        self.savingNewShiftNote = false;
        self.noteErrorMessage = getRestParamErrorMessage(err, 'note');
        
        if (!self.noteErrorMessage ) {
          // let generalError = getRestResponseErrorMessage(error);
          // console.log(generalError);
          // self.$notify({
          //   group: 'main',
          //   type: 'error',
          //   title: 'Error Updating',
          //   text: generalError ? generalError : 'An error occurred updating state license.',
          //   // duration: 5000
          // });
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: 'An error occurred saving shift note.'
          });
        }

      })
    },
    updateShiftNote (updatedShiftNote: any) {
      let self = this;
      updatedShiftNote.updatingData = true;

      HTTP.put('/api/shifts/' + this.$route.params.shiftId + '/shift-notes/' + updatedShiftNote.noteId, updatedShiftNote)
      .then(function (response) {
        updatedShiftNote.updatingData = false;
        updatedShiftNote.isEditing = false;
        updatedShiftNote.isViewing = true;
        // self.getShiftNotes();
      })
      .catch(function (error) {
        updatedShiftNote.updatingData = false;
        updatedShiftNote.noteIdErrorMessage = getRestParamErrorMessage(error, 'noteId');
        updatedShiftNote.noteErrorMessage = getRestParamErrorMessage(error, 'note');
        
        if (!updatedShiftNote.noteIdErrorMessage.length &&
          !updatedShiftNote.noteErrorMessage.length ) {
          let generalError = getRestResponseErrorMessage(error);
          self.$notify({
            group: 'main',
            type: 'error',
            title: 'Error Updating',
            text: generalError ? generalError : 'An error occurred updating shift note.',
            // duration: 5000
          });
        }

      })
    },
    deleteConfirmed (id: any) {
      this.showConfirmationModal = false;
      this.deleteShiftNote(this.pendingDeleteId, true);      
    },
    deleteShiftNote (id: any, bypassDeleteConfirmation: boolean = false) {
      if (!bypassDeleteConfirmation) {
        // Show Delete Confirmation Modal
        this.showConfirmationModal = true;
        this.pendingDeleteId = id;
        return;
      } else {
        this.pendingDeleteId = null;
      }

      let self = this
      HTTP.delete('/api/shift-note/' + id)
      .then(function (response) {
        self.getNumShiftNotes();
        self.getShiftNotes();
      })
      .catch(function (error) {
        console.log(error);
      })
    },
    toggleEditShiftNote (shiftNote: any) {
      if (shiftNote.isViewing) {
        let selectedShiftNoteId = shiftNote.noteId;
        // Collapse any editing shift notes
        // Delete any existing "new" shift notes
        let indexesToDelete: any = [];
        this.shiftNotes.forEach(function (note, index) { 
          if (note.isNew) {
            indexesToDelete.push(index);
          }
          if (selectedShiftNoteId !== note.shiftNoteId) {
            note.isEditing = false;
            note.isViewing = true;
          }
        });
        let self = this;
        indexesToDelete.forEach(function (indx: number) {
          self.shiftNotes.splice(indx,1);
        })
        shiftNote.isEditing = !shiftNote.isEditing;
        shiftNote.isViewing = !shiftNote.isViewing;
      } else {
        shiftNote.isEditing = false;
        shiftNote.isViewing = true;
        if (shiftNote.isNew) {
          // Allow the editing UI to collapse before removing it from the array.
          let self = this;
          setTimeout(function () {
            self.shiftNotes.shift();
          }, 300);
        } else {
          this.getShiftNotes();
        }
      }
      setTimeout(function () {
        document.getElementById("taShiftNote" + shiftNote.noteId)!.focus();
      }, 1000);
    },
    addShiftNote () {
      // Collapse any editing shift notes
      // Delete any existing "new" shift notes
      let indexesToDelete: any = [];
      this.shiftNotes.forEach(function (note, index) { 
        if (note.isNew) {
          indexesToDelete.push(index);
        }
        note.isEditing = false;
        note.isViewing = true;
        note.isAdding = false;
      });
      let self = this;
      indexesToDelete.forEach(function (indx: number) {
        self.shiftNotes.splice(indx,1);
      })

      // let expirationDate = new Date();
      // expirationDate.setFullYear(expirationDate.getFullYear() + 1);
      this.shiftNotes.unshift(
        {
          "shiftId": this.$route.params.shiftId,
          "createdOn": new Date(),
          "note": "",
          "isNew": true,
          "isViewing": false,
          "isEditing": true
        }
      );
      setTimeout(function () {
        document.getElementById("taShiftNote")!.focus();
      }, 1000);
    },
    cancel (shiftNote: any) {
      shiftNote.isEditing = false;
      shiftNote.isViewing = true;
      if (shiftNote.isNew) {
        // Allow the editing UI to collapse before removing it from the array.
        let self = this;
        setTimeout(function () {
          self.shiftNotes.shift();
        }, 300);
      } else {
        this.getShiftNotes();
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/shift/cards/notes/ShiftNotesCard.ts